import { Box, Center, Flex, Grid, Heading, Image, Text } from '@chakra-ui/react'
import React, { useContext, useState } from 'react'


import { Link } from 'react-router-dom';
import { ThemeContext } from './context/ThemeProvider';
import arivu from "../images/arivu.png"
import furniture from "../images/furniture.png"
import myntra from "../images/shopcart.png"
import evo from '../images/evo-home.png'
import code from "../images/Screenshot (161).png"
import shayari from '../images/Screenshot (160).png'
import { IoLogoReact } from "react-icons/io5";
import { SiChakraui } from "react-icons/si";
import { FaNodeJs } from "react-icons/fa";
import { SiExpress } from "react-icons/si";
import { SiMongodb } from "react-icons/si";
import { SiRedux } from "react-icons/si";
import { SiTypescript } from "react-icons/si";
import { SiTailwindcss } from "react-icons/si";
import { SiReacthookform } from "react-icons/si";
import { SiOpenai } from "react-icons/si";


const Project = () => {
  const {theme}=useContext(ThemeContext)
  const [isHovered1, setIsHovered1] = useState(false);
  const [isHovered2, setIsHovered2] = useState(false);
  const [isHovered3, setIsHovered3] = useState(false);
  const [isHovered4, setIsHovered4] = useState(false);
  const [isHovered5, setIsHovered5] = useState(false);
  const [isHovered6, setIsHovered6] = useState(false);
  return (
    <Box id='projects' style={theme?{color:'black'}:{color:'white'}}  mt={20} mb={20}

    >

        <Center mb={10}>
            <Heading fontWeight={'bold'} color={'rgb(4, 80, 52)'}>My Projects</Heading>
        </Center>

        <Grid templateColumns={{xl:'repeat(2,1fr)',lg:'repeat(2,1fr)',base:'repeat(1,1fr)'}} columnGap={5} rowGap={5} 
        m={{xl:'0 15vh 0 17vh'}}
        >
       <Box className="project-card" border={'1px solid gray'} borderRadius={10}  boxShadow='xl'>
        <Box p={5} 
         overflow="hidden"
         onMouseEnter={() => setIsHovered1(true)}
         onMouseLeave={() => setIsHovered1(false)}
        >
          <Image borderRadius={10} src={arivu} 
          transition="transform 0.3s"
          transform={isHovered1 ? "scale(1.2)" : "scale(1)"}
          objectFit="cover"
          cursor={'pointer'}
          />
        </Box>
        <Flex fontSize={25} justifyContent={'space-between'} p={5} flexDirection={{xl:'row',base:'column'}} gap={{lg:0,base:'2vh'}} alignItems={{xl:'center'}}>
          <Text  className="project-title" fontWeight={'bold'}>Arivu EduTech</Text>
          <Flex gap={10}>
          <Link className="project-github-link" to='https://github.com/Asimji/Arivu'>
          <Image src="https://img.shields.io/badge/GitHub-Visit-brightgreen?style=for-the-badge&logo=github" alt="GitHub Visit"/>
            </Link>
          <Link  className="project-deployed-link" to='https://puny-potato-4945.vercel.app/'>
          <Image src="https://img.shields.io/badge/Live-Demo-blue?style=for-the-badge&logo=vercel" alt="Live Demo"/>
          </Link>
          </Flex>
        </Flex>
    <Text className="project-description" fontSize={20} textAlign={'justify'} p={5}>ARIVU is an online learning platform that offers courses across various domains, similar to Coursera. This repository contains the source code for the ARIVU website.</Text>
    <Flex className="project-tech-stack" fontSize={30} textAlign={'left'}   fontWeight={'bold'} p={{xl:5,md:5,base:2}} gap={{xl:'5vh',md:'3vh',base:'2vh'}}>
      
   <IoLogoReact color='blue'/> <SiRedux />   <SiChakraui color='teal'/>   <FaNodeJs color='green'/>  <SiExpress color='gray' />  <SiMongodb color='green'/>  
    
    </Flex>
       </Box>

       <Box className="project-card" border={'1px solid gray'} borderRadius={10}  boxShadow='xl'>
        <Box p={5}  
          overflow="hidden"
          onMouseEnter={() => setIsHovered2(true)}
          onMouseLeave={() => setIsHovered2(false)}
        >
          <Image borderRadius={10} src={furniture}
          transition="transform 0.3s"
          transform={isHovered2 ? "scale(1.1)" : "scale(1)"}
          objectFit="cover"
          cursor={'pointer'}
          />
        </Box>
        <Flex fontSize={25} justifyContent={'space-between'} p={5} flexDirection={{xl:'row',base:'column'}} gap={{lg:0,base:'2vh'}}  alignItems={{xl:'center'}}>
          <Text  className="project-title" fontWeight={'bold'}>Furniture_Now </Text>
          <Flex gap={10}>
          <Link className="project-github-link" to='https://github.com/Asimji/money-reason-7925'>
          <Image src="https://img.shields.io/badge/GitHub-Visit-brightgreen?style=for-the-badge&logo=github" alt="GitHub Visit"/>
            </Link>
          <Link  className="project-deployed-link" to='https://frontend-asimji.vercel.app/'>
          <Image src="https://img.shields.io/badge/Live-Demo-blue?style=for-the-badge&logo=vercel" alt="Live Demo"/>
            </Link>
          </Flex>
        </Flex>
    <Text className="project-description" fontSize={20} textAlign={'justify'} p={5}>It is an e-commerce website that shops Online in India for Furniture, Home Decor, Homeware Products. It is an Individual project that takes 5 days to complete.</Text>
    <Flex className="project-tech-stack" fontSize={30} textAlign={'left'} fontWeight={'bold'}
    p={{xl:5,md:5,base:2}} gap={{xl:'5vh',md:'3vh',base:'2vh'}}
    >
    <IoLogoReact color='blue'/> <SiRedux />   <SiChakraui color='teal'/>   <FaNodeJs color='green'/>  <SiExpress color='gray' />  <SiMongodb color='green'/> 
       </Flex>
       </Box>
       <Box className="project-card" border={'1px solid gray'} borderRadius={10}  boxShadow='xl'>
        <Box p={5}
          overflow="hidden"
          onMouseEnter={() => setIsHovered3(true)}
          onMouseLeave={() => setIsHovered3(false)}
        >
          <Image borderRadius={10} src={myntra}
          transition="transform 0.3s"
          transform={isHovered3 ? "scale(1.1)" : "scale(1)"}
          objectFit="cover"
          cursor={'pointer'}
          />
        </Box>
        <Flex fontSize={25} justifyContent={'space-between'} p={5} flexDirection={{xl:'row',base:'column'}} gap={{lg:0,base:'2vh'}}  alignItems={{xl:'center'}}>
          <Text  className="project-title" fontWeight={'bold'}>ShopCart</Text>
          <Flex gap={10}>
          <Link className="project-github-link" to='https://github.com/Asimji/actual-size-6883'>
          <Image src="https://img.shields.io/badge/GitHub-Visit-brightgreen?style=for-the-badge&logo=github" alt="GitHub Visit"/>
          </Link>
          <Link  className="project-deployed-link" to='https://myapp-asimji.vercel.app/'>
          <Image src="https://img.shields.io/badge/Live-Demo-blue?style=for-the-badge&logo=vercel" alt="Live Demo"/>
            </Link>
          </Flex>
        </Flex>
    <Text className="project-description" fontSize={20} textAlign={'justify'} p={5}>Shopcart is a e-commerce website which is made by a group of 5 members in a span of 5 days. The motive of making this was to practice and test our skills that we acquired as of now in Masai School.</Text>
    <Flex className="project-tech-stack" fontSize={30} textAlign={'left'}  fontWeight={'bold'}
    p={{xl:5,md:5,base:2}} gap={{xl:'5vh',md:'3vh',base:'2vh'}}
    >
    <IoLogoReact color='blue'/> <SiRedux />   <SiChakraui color='teal'/>   <FaNodeJs color='green'/>  <SiExpress color='gray' />  <SiMongodb color='green'/> 
       </Flex>
       </Box>
       <Box className="project-card" border={'1px solid gray'} borderRadius={10}  boxShadow='xl'>
        <Box p={5}
          overflow="hidden"
          onMouseEnter={() => setIsHovered4(true)}
          onMouseLeave={() => setIsHovered4(false)}
        >
          <Image borderRadius={10} src={evo}
          transition="transform 0.3s"
          transform={isHovered4 ? "scale(1.1)" : "scale(1)"}
          objectFit="cover"
          cursor={'pointer'}
          />
        </Box>
        <Flex fontSize={25} justifyContent={'space-between'} p={5} flexDirection={{xl:'row',base:'column'}} gap={{lg:0,base:'2vh'}}  alignItems={{xl:'center'}}>
          <Text  className="project-title" fontWeight={'bold'}>EvoGym</Text>
          <Flex gap={10}>
          <Link className="project-github-link"  to='https://github.com/Asimji/evogym'>
            <Image src="https://img.shields.io/badge/GitHub-Visit-brightgreen?style=for-the-badge&logo=github" alt="GitHub Visit"/>
            
            </Link>
          <Link  className="project-deployed-link" to='https://evogym-buzt.vercel.app/'>
            
          <Image src="https://img.shields.io/badge/Live-Demo-blue?style=for-the-badge&logo=vercel" alt="Live Demo"/>
          </Link>
          </Flex>
        </Flex>
    <Text className="project-description" fontSize={20}  p={5} textAlign={'justify'}>EvoGym is a sleek, single-page website offers seamless navigation, engaging animations, and a user-friendly Contact section. Users can explore benefits, classes, and details about EvoGym, with email verification for added security and interactivity</Text>
    <Flex className="project-tech-stack" fontSize={30} textAlign={'left'} 
    p={{xl:5,md:5,base:2}} gap={{xl:'5vh',md:'3vh',base:'2vh'}}
    >
    <IoLogoReact color='blue'/> <SiTypescript  color='blue'/>   <SiReacthookform color='red'/>   <SiTailwindcss color='teal'/>   
       </Flex>
       </Box> 
        <Box className="project-card" border={'1px solid gray'} borderRadius={10}  boxShadow='xl'>
        <Box p={5}
          overflow="hidden"
          onMouseEnter={() => setIsHovered5(true)}
          onMouseLeave={() => setIsHovered5(false)}
        >
          <Image borderRadius={10} src={shayari}
          transition="transform 0.3s"
          transform={isHovered5 ? "scale(1.1)" : "scale(1)"}
          objectFit="cover"
          cursor={'pointer'}
          />
        </Box>
        <Flex fontSize={25} justifyContent={'space-between'} p={5} flexDirection={{xl:'row',base:'column'}} gap={{lg:0,base:'2vh'}}  alignItems={{xl:'center'}}>
          <Text  className="project-title" fontWeight={'bold'}>Shayari App</Text>
          <Flex gap={10}>
          <Link className="project-github-link"  to='https://github.com/Asimji/Shayari_Generator'>
            <Image src="https://img.shields.io/badge/GitHub-Visit-brightgreen?style=for-the-badge&logo=github" alt="GitHub Visit"/>
            
            </Link>
          <Link  className="project-deployed-link" to='https://shayari-generator-beta.vercel.app/'>
            
          <Image src="https://img.shields.io/badge/Live-Demo-blue?style=for-the-badge&logo=vercel" alt="Live Demo"/>
          </Link>
          </Flex>
        </Flex>
    <Text className="project-description" fontSize={20} textAlign={'justify'} p={5}>Unleash your creativity with our Shayari Generator, a delightful project that transforms your input words into beautiful, heartfelt Shayari effortlessly.</Text>
    <Flex className="project-tech-stack" fontSize={30} textAlign={'left'} 
    p={{xl:5,md:5,base:2}} gap={{xl:'5vh',md:'3vh',base:'2vh'}}
    >
    <IoLogoReact color='blue'/> <SiChakraui  color='teal'/>   <FaNodeJs color='green'/>   <SiOpenai color='#0ea47e'/>   
       </Flex>
       </Box>
       
         <Box className="project-card" border={'1px solid gray'} borderRadius={10}  boxShadow='xl'>
        <Box p={5}
          overflow="hidden"
          onMouseEnter={() => setIsHovered6(true)}
          onMouseLeave={() => setIsHovered6(false)}
        >
          <Image borderRadius={10} src={code}
          transition="transform 0.3s"
          transform={isHovered6 ? "scale(1.1)" : "scale(1)"}
          objectFit="cover"
          cursor={'pointer'}
          />
        </Box>
        <Flex fontSize={25} justifyContent={'space-between'} p={5} flexDirection={{xl:'row',base:'column'}} gap={{lg:0,base:'2vh'}}  alignItems={{xl:'center'}}>
          <Text  className="project-title" fontWeight={'bold'}>Code Convertor</Text>
          <Flex gap={10}>
          <Link className="project-github-link"  to='https://github.com/Asimji/Code_Convertor'>
            <Image src="https://img.shields.io/badge/GitHub-Visit-brightgreen?style=for-the-badge&logo=github" alt="GitHub Visit"/>
            
            </Link>
          <Link  className="project-deployed-link" to='https://code-convertor-kappa.vercel.app/'>
            
          <Image src="https://img.shields.io/badge/Live-Demo-blue?style=for-the-badge&logo=vercel" alt="Live Demo"/>
          </Link>
          </Flex>
        </Flex>
    <Text className="project-description" fontSize={20} textAlign={'justify'} p={5}>This project empowers developers to seamlessly convert their code into different programming languages, perform real-time debugging, and ensure code quality.</Text>
    <Flex className="project-tech-stack" fontSize={30} textAlign={'left'} 
    p={{xl:5,md:5,base:2}} gap={{xl:'5vh',md:'3vh',base:'2vh'}}
    >
    <IoLogoReact color='blue'/> <SiChakraui  color='teal'/>   <FaNodeJs color='green'/>   <SiOpenai color='#0ea47e'/>   
       </Flex>
       </Box>
       
  

       

        </Grid>
      
    </Box>
  )
}

export default Project
